import { useState } from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { Invitation } from "@/types/team";
import { RevokeInvitationDialog } from "./RevokeInvitationDialog";

interface InvitationActionsMenuProps {
  invitation: Invitation;
  isResending: boolean;
  onResend: (id: string) => void;
}

export function InvitationActionsMenu({
  invitation,
  isResending,
  onResend,
}: InvitationActionsMenuProps) {
  const [revokeDialogOpen, setRevokeDialogOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() => onResend(invitation.id)}
            disabled={isResending}
          >
            {isResending ? "Resending..." : "Resend invitation"}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setRevokeDialogOpen(true)}>
            Revoke invitation
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <RevokeInvitationDialog
        invitationId={invitation.id}
        email={invitation.email}
        open={revokeDialogOpen}
        onOpenChange={setRevokeDialogOpen}
      />
    </>
  );
}
